import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import elementOffset from '../../utils/elementOffset';
import './Scrollspy.scss';
import ImageWebp from '../ImageWebp/ImageWebp';
// import LogoAnim from '../LogoAnim/logoAnim';

const Scrollspy = ({ children }) => {
  const [activeSection, setActiveSection] = useState(0);
  const [menuItems, setMenuItems] = useState([]);

  const containerRef = useRef();
  const spyRef = useRef();

  const [mainMenuOpen, setmainMenuOpen] = useState(false);

  const mainMenuOpenToggle = useCallback(() => {
    setmainMenuOpen((state) => !state);
  }, []);

  const scrollHandler = useCallback(() => {
    if (menuItems.length > 0) {
      let lastID = 0;

      menuItems.forEach(({ el, id }) => {
        if (window.pageYOffset > elementOffset(el, 'top') - 150) lastID = id;
      });

      setActiveSection(lastID);
    }
  }, [menuItems]);

  const linkClickHandler = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    window.scrollTo({
      top:
        elementOffset(
          document.querySelector(
            `[data-spy-id="${new URL(e.target.href).hash.replace('#', '')}"]`,
          ),
          'top',
        ) - 40,
      left: 0,
      behavior: 'smooth',
    });
    setmainMenuOpen(false);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const elements = containerRef.current.querySelectorAll('[data-spy-id]');

      setMenuItems(
        Array.from(elements).map((el) => ({
          id: el.dataset.spyId,
          label: el.dataset.spyTitle || el.dataset.spyId,
          el,
        })),
      );
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);

    return () => window.removeEventListener('scroll', scrollHandler);
  }, [scrollHandler]);
  const scrollProgress = useRef();
  useEffect(() => {
    window.onscroll = function () {
      fixHeader();

      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      scrollProgress.current.style.height = `${scrollPercentRounded}%`;
    };

    const header = containerRef.current;
    const sticky = header.offsetTop;

    function fixHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    }
  }, []);

  return (
    <>
      <div className="scroll-progress-main">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          fill="none"
          viewBox="0 0 10 6">
          <path stroke="#fff" strokeLinecap="round" d="m1 5 4-4 4 4" />
        </svg>
        <div className="scroll-progress">
          <span ref={scrollProgress}>&nbsp;</span>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          fill="none"
          viewBox="0 0 10 6">
          <path stroke="#fff" strokeLinecap="round" d="m1 1 4 4 4-4" />
        </svg>
      </div>
      <div ref={containerRef}>
        <div
          ref={spyRef}
          className={`site-header-main scrollspy${
            activeSection ? ' is-sticky' : ''
          }`}>
          <div className="container">
            <div className="row row-no-margin">
              <div className="col-4">
                <div className="header-logo">
                  {/* <LogoAnim /> */}
                  <ImageWebp
                    srcWebp="https://ftx-rp.netlify.app/img/ftx21.webp"
                    src="https://ftx-rp.netlify.app/img/ftx21.png"
                    alt=""
                    loading="lazy"
                    className="logo"
                  />

                  <p>The Ultimate FinTech Conference for Disruptors</p>
                </div>
              </div>

              <div className="col-8">
                <div className={`nav-main ${mainMenuOpen ? 'nav-open' : ''}`}>
                  <button
                    onClick={mainMenuOpenToggle}
                    type="button"
                    className="nav-trigger">
                    <span>&nbsp;</span>
                  </button>
                  <nav>
                    {menuItems.map(({ id, label }) => (
                      <Link
                        key={id}
                        to={`#${id}`}
                        className={id === activeSection ? 'is-active' : ''}
                        onClick={linkClickHandler}>
                        {label}
                      </Link>
                    ))}
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

Scrollspy.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Scrollspy;
